<template>
  <div class="page light intro">
    <div class="inner">
      <h1>Accomodation</h1>
        
        <p>
          Please visit <a href="http://www.masonsarmsdevon.co.uk/Noticeboard/local-info/local_information.php">Masons Arms</a> to see information on local accommodation in and around Knowstone.
        </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'intro'
}
</script>

<style scoped lang="scss">
.intro{

padding-top:150px;
  display: flex;
  align-items: center;
  justify-content: center;
  .inner{
    max-width: 1200px;
    
    padding:0 5%;

  }
}

</style>
